import React from 'react';
import FungsiView from '../pages/Master/crude/FungsiView';
import ClausaCategoryView from '../pages/Master/crude/ClausaCategoryView';
import MatrixEvaluasiTenderView from '../pages/Master/crude/MatrixEvaluasiTenderView';
import ClausaInformationView from '../pages/Master/crude/ClausaInformationView';
import ReviewalListView from '../pages/Master/crude/ReviewalListView';
import ApprovalListView from '../pages/Master/crude/ApprovalListView';
import MyChangesView from '../pages/Master/crude/MyChangesView';
import CrudeCategoryView from '../pages/Master/crude/CrudeCategoryView';
import CduView from '../pages/Master/crude/CduView';
import EvaluationDocumentView from '../pages/Master/crude/EvaluationDocumentView';
import ReceptionFacilitiesView from '../pages/Master/crude/ReceptionFacilitiesView';
import DocumentUploadView from '../pages/Master/crude/DocumentUploadView';
import AuditView from '../pages/Crude/Audit/AuditView';
import AuditDetailView from '../pages/Crude/Audit/AuditDetailView';
import GeneralReportView from '../pages/Crude/Reports/GeneralReportView';
import EvaluationReportView from '../pages/Crude/Reports/EvaluationReportView';
import MonitoringReportView from '../pages/Crude/Reports/MonitoringReportView';
import FacilityReportView from '../pages/Crude/Reports/FacilityReportView';
import DataTrackingView from '../pages/Master/crude/DataTrackingView';
import PcPpmDataTrackingView from '../pages/Crude/PcppmDataTracking/PcPpmDataTrackingView';
import DmutListView from '../pages/Crude/DmutList/DmutListView';
import PlanningView from '../pages/Crude/PlanAndProcurement/Planning/PlanningView';
import PlanningForm from '../pages/Crude/PlanAndProcurement/Planning/PlanningForm';
import PlanningDetail from '../pages/Crude/PlanAndProcurement/Planning/PlanningDetail';
import ProcurementView from '../pages/Crude/PlanAndProcurement/Procurement/ProcurementView';
import ProcurementForm from '../pages/Crude/PlanAndProcurement/Procurement/ProcurementForm';
import ProcurementDetail from '../pages/Crude/PlanAndProcurement/Procurement/ProcurementDetail';
import InvitationExternalListView from '../pages/Crude/PlanAndProcurement/InvitationExternal/InvitationExternalListView';
import InvitationExternalDetailView from '../pages/Crude/PlanAndProcurement/InvitationExternal/InvitationExternalDetailView';
import InvitationInternalListView from '../pages/Crude/PlanAndProcurement/InvitationInternal/InvitationInternalListView';
import InvitationInternalDetailView from '../pages/Crude/PlanAndProcurement/InvitationInternal/InvitationInternalDetailView';
import RegistrationListView from '../pages/Crude/Registration/RegistrationListView';
import RegistrationCreateView from '../pages/Crude/Registration/RegistrationCreateView';
import RegistrationDetailView from '../pages/Crude/Registration/RegistrationDetailView';
import HpsListView from '../pages/Crude/PlanAndProcurement/Hps/HpsListView';
import TenderOpeningListView from '../pages/Crude/PlanAndProcurement/TenderOpening/TenderOpeningListView';
import TenderOpeningDetailView from '../pages/Crude/PlanAndProcurement/TenderOpening/TenderOpeningDetailView';
import OfferingListView from '../pages/Crude/PlanAndProcurement/Offering/OfferingListView';
import OfferingDetailView from '../pages/Crude/PlanAndProcurement/Offering/OfferingDetailView';

const crudeProtectedRoutes = [
  {
    path: '/crude/fungsi',
    component: <FungsiView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/clausa-category',
    component: <ClausaCategoryView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/matrix-evaluasi-tender',
    component: <MatrixEvaluasiTenderView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/clausa-information',
    component: <ClausaInformationView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/reviewal-list',
    component: <ReviewalListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/approval-list',
    component: <ApprovalListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/my-changes',
    component: <MyChangesView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/crude-category',
    component: <CrudeCategoryView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/cdu',
    component: <CduView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/evaluation-document',
    component: <EvaluationDocumentView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/reception-facilities',
    component: <ReceptionFacilitiesView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/document-upload',
    component: <DocumentUploadView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/audit-log',
    component: <AuditView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/audit-log/dtl/:id',
    component: <AuditDetailView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/data-tracking',
    component: <DataTrackingView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/pcppm-data-tracking',
    component: <PcPpmDataTrackingView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/dmut-list',
    component: <DmutListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/registration',
    component: <RegistrationListView />,
    roles: ['Super Admin'],
  },
  {
    // Create wizard (3 tabs). 3-level path is fine — it shares the
    // `crude/registration` 2-segment prefix so isRouteActive keeps the sidebar
    // active on the same "Registration" menu item.
    path: '/crude/registration/create',
    component: <RegistrationCreateView />,
    roles: ['Super Admin'],
  },
  {
    // Detail page (read-only header + Assay table + Add/Edit Assay). Shares the
    // `crude/registration` 2-segment prefix so isRouteActive keeps the sidebar
    // "Registration" item active. The List's Detail (eye) action links here.
    path: '/crude/registration/dtl/:id',
    component: <RegistrationDetailView />,
    roles: ['Super Admin'],
  },
  {
    // Flat 2-level path required: isRouteActive() (src/utils/routeMatch.js)
    // only compares the first two `/crude/...` segments to decide sidebar
    // active state. Three sibling report pages sharing a 3-level prefix
    // (/crude/reports/general|evaluation|monitoring) would all resolve to the
    // same crude/reports prefix and couldn't be told apart.
    path: '/crude/reports-general',
    component: <GeneralReportView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/reports-evaluation',
    component: <EvaluationReportView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/reports-monitoring',
    component: <MonitoringReportView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/reports-facility',
    component: <FacilityReportView />,
    roles: ['Super Admin'],
  },
  // Plan & Procurement — Planning module. List + create/edit detail + view-only
  // detail. `roles` is dead (access is permission-based via /menu/me) but kept
  // for consistency with the siblings above.
  {
    path: '/crude/planning',
    component: <PlanningView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/planning/create/:id',
    component: <PlanningForm />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/planning/dtl/:id',
    component: <PlanningDetail />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/procurement',
    component: <ProcurementView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/procurement/create/:id',
    component: <ProcurementForm />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/procurement/dtl/:id',
    component: <ProcurementDetail />,
    roles: ['Super Admin'],
  },
  // Invitation - External (DMUT) — the DMUT-facing side of the invitation issued
  // during Planning/Procurement: list + view-only Detail with Accept/Decline.
  // Dummy-backed (no contract yet); see invitationExternalApi.js. The sidebar
  // entry is not defined here — the menu comes from /menu/me, so this path also
  // has to be registered as a menu item backend-side to be reachable and to pass
  // ProtectedRoute's canRead check.
  {
    path: '/crude/invitation-external',
    component: <InvitationExternalListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/invitation-external/dtl/:id',
    component: <InvitationExternalDetailView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/invitation-internal',
    component: <InvitationInternalListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/invitation-internal/dtl/:id',
    component: <InvitationInternalDetailView />,
    roles: ['Super Admin'],
  },
  // Offering — DMUT-facing offer submission flow. List only for now; Detail
  // will be added next session. Dummy-backed (no BE contract yet).
  {
    path: '/crude/offering',
    component: <OfferingListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/offering/dtl/:id',
    component: <OfferingDetailView />,
    roles: ['Super Admin'],
  },
  // HPS list — list only (dummy-backed) for now. The stage after
  {
    path: '/crude/hps-list',
    component: <HpsListView />,
    roles: ['Super Admin'],
  },
  // Tender Opening — the stage after Procurement. List + one shared Detail
  // component driven by `mode` ('view' for /dtl, 'edit' for /edit) — see
  // TenderOpeningDetailView.js. `roles` is dead (access is permission-based via
  // /menu/me) but kept for consistency with the siblings above.
  {
    path: '/crude/tender-opening',
    component: <TenderOpeningListView />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/tender-opening/dtl/:id',
    component: <TenderOpeningDetailView mode='view' />,
    roles: ['Super Admin'],
  },
  {
    path: '/crude/tender-opening/edit/:id',
    component: <TenderOpeningDetailView mode='edit' />,
    roles: ['Super Admin'],
  },
];

export { crudeProtectedRoutes };
